var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponseAcceptedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 7H51.0003V35H9.00024V7Z",
    fill: "#9BC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 0H5C2.23975 0.00341798 0.00341856 2.23975 5.88852e-07 5V59C-0.000487692 59.4521 0.302735 59.8481 0.73877 59.9658C0.824219 59.9888 0.91211 60 1 60C1.35645 59.9995 1.68555 59.8086 1.86377 59.5L12.0742 42H55C57.7603 41.9966 59.9966 39.7603 60 37V5C59.9966 2.23975 57.7603 0.00341798 55 0ZM58 37C58 38.6567 56.6567 40 55 40H11.5C11.1436 40.0005 10.8145 40.1914 10.6362 40.5L2 55.2998V5C2 3.34326 3.34326 2 5 2H55C56.6567 2 58 3.34326 58 5V37Z",
    fill: "#57A4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9468 6.68115C51.8101 6.27441 51.4293 6.00049 51.0001 6H9.00006C8.57086 6.00049 8.19 6.27441 8.05328 6.68115C8.01764 6.78369 8.00006 6.8916 8.00006 7V35C8.00006 35.5522 8.44781 36 9.00006 36H51.0001C51.5523 36 52.0001 35.5522 52.0001 35V7C52.0001 6.8916 51.9825 6.78369 51.9468 6.68115ZM24.981 20.4331L29.3941 23.7998C29.752 24.0728 30.2481 24.0728 30.606 23.7998L35.0201 20.437L48.586 34H11.4141L24.981 20.4331ZM10.0001 32.5859V9.01904L23.376 19.21L10.0001 32.5859ZM36.6251 19.21L50.0001 9.01904V32.5859L36.6251 19.21ZM48.0381 8L30.0001 21.7432L11.962 8H48.0381Z",
    fill: "#57A4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseAcceptedIcon);
export default __webpack_public_path__ + "static/media/response-accepted-icon.c588a12e5ae042fe6bc608ec4011646a.svg";
export { ForwardRef as ReactComponent };